const STORAGE_KEY = "pm_recent_items";
const MAX_ITEMS = 15;

const getStorageKey = (userId) => `pm_recent_items_${userId}`;

export const getRecentItems = (userId) => {
  if (!userId) return [];

  try {
    return JSON.parse(localStorage.getItem(getStorageKey(userId))) || [];
  } catch {
    return [];
  }
};

export const addRecentItem = (userId, item) => {
  if (!userId) return;

  try {
    const existing = getRecentItems(userId);

    // remove duplicate (same type + id)
    const filtered = existing.filter(
      (i) => !(i.id === item.id && i.type === item.type),
    );

    const updated = [{ ...item, openedAt: Date.now() }, ...filtered].slice(
      0,
      MAX_ITEMS,
    );

    localStorage.setItem(getStorageKey(userId), JSON.stringify(updated));
  } catch (err) {
    console.error("Failed to update recent items", err);
  }
};

export const clearRecentItems = (userId) => {
  if (!userId) return;
  localStorage.removeItem(getStorageKey(userId));
};
